import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/** The admin console moved to its own full-width page; old links and bookmarks land there. */
export const Route = createFileRoute('/_app/settings/admin')({
  validateSearch: z.object({
    view: z.enum(['users', 'wallets', 'platform']).optional().catch(undefined),
    user: z
      .string()
      .regex(/^[a-f0-9]{24}$/)
      .optional()
      .catch(undefined),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/admin', search, replace: true });
  },
});
